export default "__VITE_ASSET__Mo6CK$A$__"